// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__36NJ3","iconInsideLeft":"Input_iconInsideLeft__1Xq-j","iconInsideRight":"Input_iconInsideRight__uOgIU","inputfile":"Input_inputfile__2dMc9"};